const c = {
  name: "FormulaCreateOwnPath",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M4,0v10.2c0.9,0.3,1.5,1,1.8,1.8h10.3c0.4-1.2,1.5-2,2.8-2c1.7,0,3,1.3,3,3c0,1.3-0.8,2.4-2,2.8V30h-6.2
			c-0.4,1.2-1.5,2-2.8,2c-1.7,0-3-1.3-3-3c0-1.3,0.8-2.4,2-2.8V22H7c-1.7,0-3,1.3-3,3v9.2c0.9,0.3,1.5,1,1.8,1.8h18.3
			c0.4-1.2,1.5-2,2.8-2c1.3,0,2.4,0.8,2.8,2H40v2H29.8c-0.4,1.2-1.5,2-2.8,2c-1.3,0-2.4-0.8-2.8-2H5.8c-0.4,1.2-1.5,2-2.8,2
			c-1.7,0-3-1.3-3-3c0-1.3,0.8-2.4,2-2.8V25c0-2.8,2.2-5,5-5h5v6.2c0.9,0.3,1.5,1,1.8,1.8H18V15.8c-0.9-0.3-1.5-1-1.8-1.8H5.8
			c-0.4,1.2-1.5,2-2.8,2c-1.7,0-3-1.3-3-3c0-1.3,0.8-2.4,2-2.8V0H4z M3,12c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1c0.6,0,1-0.4,1-1
			C4,12.4,3.6,12,3,12z M19,12c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1s1-0.4,1-1C20,12.4,19.6,12,19,12z M10,29c0,0.6,0.4,1,1,1
			c0.6,0,1-0.4,1-1s-0.4-1-1-1C10.4,28,10,28.4,10,29z M3,36c-0.6,0-1,0.4-1,1s0.4,1,1,1c0.6,0,1-0.4,1-1S3.6,36,3,36z M26,37
			c0,0.6,0.4,1,1,1s1-0.4,1-1s-0.4-1-1-1S26,36.4,26,37z"/>
		<path class="st0" d="M11,6c0.6,0,1-0.4,1-1c0-0.6-0.4-1-1-1c-0.6,0-1,0.4-1,1C10,5.6,10.4,6,11,6z"/>
		<path class="st0" d="M20,5c0,0.6-0.4,1-1,1s-1-0.4-1-1c0-0.6,0.4-1,1-1S20,4.4,20,5z"/>
		<path class="st0" d="M27,6c0.6,0,1-0.4,1-1c0-0.6-0.4-1-1-1s-1,0.4-1,1C26,5.6,26.4,6,27,6z"/>
		<path class="st0" d="M36,5c0,0.6-0.4,1-1,1c-0.6,0-1-0.4-1-1c0-0.6,0.4-1,1-1C35.6,4,36,4.4,36,5z"/>
		<path class="st0" d="M27,14c0.6,0,1-0.4,1-1c0-0.6-0.4-1-1-1s-1,0.4-1,1C26,13.6,26.4,14,27,14z"/>
		<path class="st0" d="M36,13c0,0.6-0.4,1-1,1c-0.6,0-1-0.4-1-1c0-0.6,0.4-1,1-1C35.6,12,36,12.4,36,13z"/>
		<path class="st0" d="M27,22c0.6,0,1-0.4,1-1s-0.4-1-1-1s-1,0.4-1,1S26.4,22,27,22z"/>
		<path class="st0" d="M36,21c0,0.6-0.4,1-1,1c-0.6,0-1-0.4-1-1s0.4-1,1-1C35.6,20,36,20.4,36,21z"/>
		<path class="st0" d="M27,30c0.6,0,1-0.4,1-1s-0.4-1-1-1s-1,0.4-1,1S26.4,30,27,30z"/>
		<path class="st0" d="M36,29c0,0.6-0.4,1-1,1c-0.6,0-1-0.4-1-1s0.4-1,1-1C35.6,28,36,28.4,36,29z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as FormulaCreateOwnPath
};
